module.exports = __webpack_public_path__ + "media/images/policy-circles-70c67fc420221c388c0ccb151538322a.png";